import {
	Backdrop,
	Box,
	Button,
	CircularProgress,
	Divider,
	Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { colors } from "../setupUtils";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import EditIcon from "@mui/icons-material/Edit";
import CommentIcon from "@mui/icons-material/Comment";
import { useDispatch, useSelector } from "react-redux";
import Message from "../Message";
import { useState } from "react";
import {
	getCGRefData,
	getCustomers,
	getCustomersAuto,
	getUserCountries,
	resetAllStates,
	setCGState,
} from "./customerGroupSetupSlice";
import SearchCG from "./edit/SearchCG";
import CreateCG from "./create/CreateCG";
import SelectCustomer from "./SelectCustomer";
import Attachments from "./Attachments";
import Comments from "./Comments";
import Summary from "./Summary";
import FileUpload from "./FileUpload";
import CreateSelectCustomer from "./create/CreateSelectCustomer";
import CreateFileUpload from "./create/CreateFileUpload";
import CreateAttachments from "./create/CreateAttachments";
import CreateComments from "./create/CreateComments";
import CreateSummary from "./create/CreateSummary";
import CreateMessage from "./create/CreateMessage";
import dayjs from "dayjs";
import Popup from "./edit/Popup";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function CustomerGroupSetup() {
	const dispatch = useDispatch();
	const cgState = useSelector((store) => store.customerGroupSetup);
	const {
		isEdit,
		isLoading,
		countries,
		customerLevels,
		customerTypes,
		customers,
      countryID
	} = cgState;

	useEffect(() => {
		//if (countries.length === 0) {
			dispatch(getUserCountries())
		//}
      dispatch(resetAllStates({ edit: true }));
	}, []);

	function showMessage(message, severity) {}

	function changeScreen() {
		dispatch(setCGState("isEdit", !isEdit));
      dispatch(resetAllStates({ edit: false }));
	}

	function getCurrentDateTime() {
		const date = new Date();
		const year = date.getFullYear();
		const month = date.getMonth() + 1;
		const day = date.getDate();
		const hours = date.getHours();
		const minutes = date.getMinutes();
		const seconds = date.getSeconds();
		const formattedDate = `${year}${month}${day} ${hours}${minutes}${seconds}`;
		return formattedDate;
	}

	function delay(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}

	function getRandomIndex(min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	async function setValues() {
		dispatch(
			getCustomersAuto({
				countryID: 172,
				customerTypeCode: "P20",
				customerLevelID: "SH",
				customerName: "",
				activeCustomer: true,
				relShipLevelID: 1,
				newCustomer: false,
			})
		);

		dispatch(setCGState("country", "Germany"));
		dispatch(setCGState("countryID", 172));

		const name = `CG ${getCurrentDateTime()}`;
		dispatch(setCGState("createCGName", name));

		dispatch(setCGState("customerType", "Wholes. Pharmaceut."));
		dispatch(setCGState("customerTypeCode", "P20"));

		dispatch(setCGState("createFromDate", dayjs()));
		dispatch(setCGState("createToDate", dayjs().add(2, "year")));

		dispatch(setCGState("customerLevel", "Ship-to"));
		dispatch(setCGState("customerLevelID", "SH"));

		dispatch(setCGState("relShipLevel", "High"));
		dispatch(setCGState("relShipLevelID", 1));

		dispatch(setCGState("activeCustomer", true));
		dispatch(setCGState("createComments", `TEST: ${name}`));
	}

	function resetValues() {
		dispatch(setCGState("country", ""));
		dispatch(setCGState("countryID", ""));
		dispatch(setCGState("createCGName", ""));

		dispatch(setCGState("customerType", ""));
		dispatch(setCGState("customerTypeCode", ""));

		dispatch(setCGState("customerLevel", ""));
		dispatch(setCGState("customerLevelID", ""));

		dispatch(setCGState("relShipLevel", "All"));
		dispatch(setCGState("relShipLevelID", 0));

		dispatch(setCGState("activeCustomer", false));

		dispatch(setCGState("customers", []));
		dispatch(setCGState("selCustomers", []));

		dispatch(setCGState("createComments", ""));

		dispatch(setCGState("createEditStartEndDateModalOpened", false));
	}

	return (
		<Box sx={{ p: 1 }}>
			{/* LOADING SCREEN */}
			<Box>
				<Backdrop
					sx={{
						color: "#fff",
						zIndex: (theme) => theme.zIndex.drawer + 1,
					}}
					open={isLoading}
				>
					<CircularProgress />
				</Backdrop>
			</Box>

			{/* MESSAGE, INFO, ERROR, SUCCESS */}
			{/* <Box>{isEdit ? <Popup /> : <CreateMessage />}</Box> */}
			<Box>
				<Popup /> 
				<CreateMessage />
			</Box>
			{/* SEARCH FOR CUSTOMER GROUP / CREATE CUSTOMER GROUP LABEL
            CREATE CUSTOMER GROUP / EDIT CUSTOMER GROUP BUTTON */}
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					mt: 3,
				}}
			>
				<Typography variant="subtitle1" color={colors.black}>
					{isEdit ? "Search for Customer Group" : "Create Customer Group"}
				</Typography>

				{/* FOR TESTING PURPOSES ONLY */}
				{/* <Button
					sx={{
						bgcolor: colors.blue,
						color: colors.white,
						textTransform: "none",
						"&:hover": {
							bgcolor: colors.lightBlue,
						},
					}}
					onClick={setValues}
				>
					SET VALUES
				</Button>

				<Button
					sx={{
						bgcolor: colors.blue,
						color: colors.white,
						textTransform: "none",
						"&:hover": {
							bgcolor: colors.lightBlue,
						},
					}}
					onClick={resetValues}
				>
					RESET VALUES
				</Button> */}
				{/* FOR TESTING PURPOSES ONLY */}

				<Button
					startIcon={isEdit ? <NoteAddIcon /> : <EditIcon />}
					sx={{
						bgcolor: "darkBlue.light",
						color: colors.white,
						textTransform: "none",
						"&:hover": {
							bgcolor: "darkBlue.main",
							color: colors.white,
						},
					}}
					onClick={changeScreen}
				>
					{isEdit ? "Create Customer Group" : "Edit Customer Group"}
				</Button>
			</Box>

			{/* SEARCH FOR CUSTOMER GROUP / CREATE CUSTOMER GROUP */}
			{isEdit ? <SearchCG /> : <CreateCG />}
			{/* SELECT CUSTOMER */}
			{isEdit ? <SelectCustomer /> : <CreateSelectCustomer />}
			{/* <Divider sx={{ mt: 4 }} /> */}

			{/* COMMENTS AND ATTACHMENTS LABEL */}
			{/* <Box sx={{ mt: 3, display: "flex", flexDirection: "row" }} >
				<Typography sx={{ fontWeight: "bold", color: "blue.main", width: "100%", }} 
				className="compHeading"
				>
				<CommentIcon sx={{ color: "blue.main", mr: 1, height: "18px" }}/>
					Attachments
				</Typography>
			</Box> */}
			<CollapseSection title="Attachments">
				{/* FILE UPLOAD */}
				{isEdit ? <FileUpload /> : <CreateFileUpload />}
				{/* ATTACHMENTS */}
				{isEdit ? <Attachments /> : <CreateAttachments />}
			</CollapseSection>
			<CollapseSection title="Comments">
				{/* COMMENTS */}
				{isEdit ? <Comments /> : <CreateComments />}
			</CollapseSection>
			{/* SUMMARY */}
			{isEdit ? <Summary /> : <CreateSummary />}
		</Box>
	);
}
